import { _decorator, Node, Enum } from 'cc';
import { DEV } from 'cc/env';
import NeutrinoComponentBase from '../../Components/NeutrinoParticle/NeutrinoComponentBase';
import BaseAction from './BaseAction';

const { ccclass, property } = _decorator;

// 粒子額外行為
export enum NeutrinoParticleActionType {
    None,
    Restart,
    ResetPosition,
    PauseEmitterOnEmpty,
}

@ccclass('NeutrinoParticleAction')
export default class NeutrinoParticleAction extends BaseAction {
    @property({ type: NeutrinoComponentBase, displayName: DEV && 'N粒子元件', tooltip: DEV && 'NeutrinoParticle 元件' })
    public readonly particle: NeutrinoComponentBase = null;
    @property({
        displayName: DEV && '控制粒子系統暫停狀態',
        tooltip: DEV && '是否要調整粒子系統暫停狀態',
    })
    public readonly updatePauseState: boolean = false;
    @property({
        displayName: DEV && '粒子系統暫停狀態',
        tooltip: DEV && '粒子系統暫停狀態',
        visible() {
            return this.updatePauseState;
        },
    })
    public readonly pauseState: boolean = false;
    @property({
        displayName: DEV && '控制發射器暫停狀態',
        tooltip: DEV && '是否要調整發射器暫停狀態',
    })
    public readonly updateEmitterPauseState: boolean = false;
    @property({
        displayName: DEV && '發射器暫停狀態',
        tooltip: DEV && '發射器暫停狀態',
        visible() {
            return this.updateEmitterPauseState;
        },
    })
    public readonly emitterPauseState: boolean = false;
    @property({
        type: Enum(NeutrinoParticleActionType),
        displayName: DEV && '額外操作',
        tooltip:
            DEV &&
            '要進行什麼行為\r\nNone: 啥都不做zz\r\nRestart: 重新啟動粒子系統\r\nResetPosition: 重設座標(不觸發拖尾)\r\nPauseEmitterOnEmpty: 等待無粒子時再將發射器暫停',
    })
    public readonly type: NeutrinoParticleActionType = NeutrinoParticleActionType.None;
    @property({
        displayName: DEV && '重設坐標目標',
        tooltip: DEV && '重設坐標的目標節點',
        type: Node,
        visible() {
            return this.type === NeutrinoParticleActionType.ResetPosition;
        },
    })
    public readonly resetPositionTargetNode: Node = null;
}
